export const stemsData = {
  "brands": {
    "brand_01": {
      "id": "brand_01",
      "name": "Brand 01",
      "stems": {
        "base": {
          "main": [{ "power": 1, "variations": [0] }],
          "bass": [{ "power": 1, "variations": [0] }],
          "chord": [{ "power": 1, "variations": [0] }],
          "layer": [{ "power": 1, "variations": [0] }],
          "sfx": [{ "power": 1, "variations": [0] }]
        },
        "calm": {
          "main": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "bass": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "layer": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "sfx": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ]
        },
        "energetic": {
          "main": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "bass": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "layer": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        },
        "hyper": {
          "main": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "bass": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "layer": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        },
        "serious": {
          "main": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "bass": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ],
          "layer": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        }
      }
    },
    "brand_02": {
      "id": "brand_02",
      "name": "Brand 02",
      "stems": {
        "base": {
          "main": [],
          "bass": [],
          "chord": [],
          "layer": [],
          "sfx": []
        },
        "calm": {
          "main": [],
          "bass": [],
          "chord": [],
          "layer": [],
          "sfx": []
        },
        "energetic": {
          "main": [],
          "bass": [],
          "chord": [],
          "layer": [],
          "sfx": []
        },
        "hyper": {
          "main": [],
          "bass": [],
          "chord": [],
          "layer": [],
          "sfx": []
        },
        "serious": {
          "main": [],
          "bass": [],
          "chord": [],
          "layer": [],
          "sfx": []
        }
      }
    },
    "brand_03": {
      "id": "brand_03",
      "name": "Brand 03",
      "stems": {
        "base": {
          "main": [{ "power": 1, "variations": [0] }],
          "bass": [{ "power": 1, "variations": [0] }],
          "chord": [{ "power": 1, "variations": [0] }],
          "layer": [{ "power": 1, "variations": [0] }],
          "sfx": [{ "power": 1, "variations": [0] }]
        },
        "calm": {
          "main": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "bass": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "layer": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        },
        "energetic": {
          "main": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ],
          "bass": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "layer": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        },
        "hyper": {
          "main": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ],
          "bass": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0] }
          ],
          "layer": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        },
        "serious": {
          "main": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ],
          "bass": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "chord": [
            { "power": 1, "variations": [0, 1] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [1] }
          ],
          "layer": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0] },
            { "power": 3, "variations": [0, 1] }
          ],
          "sfx": [
            { "power": 1, "variations": [0] },
            { "power": 2, "variations": [0, 1] },
            { "power": 3, "variations": [0, 1] }
          ]
        }
      }
    }
  }
}